<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-10 17:01:53
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:11:07
 * @Description: 更多精彩，聊天，分享 
 高度 50px
 下边距 20px
 -->
<template>
  <div class="tabbar11" :style="tabbarStyle">
    <div
      v-for="item in evenNavData"
      class="tabbar_item"
      @click="clickItem(item)"
      :class="item.class"
      :style="item.style"
    >
      <div class="tabbar_icon">
        <img v-if="item.ico" :src="item.ico" />
      </div>
      <span class="tabbar_text">{{item.name}}</span>
    </div>
    <HdkShareGuide v-if="isShowHdkShareGuide" v-on:close="closeHdkShareGuide"></HdkShareGuide>
    <ShowImg2 v-if="showImg2.isShow" :my="showImg2" v-on:close="showImg2.isShow=false"></ShowImg2>
  </div>
</template>
<script>
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import { MessageBox } from "mint-ui";
const ShareGuide = () => import("@/components/share_guide4.vue");
import Canvastoimg from "wtc-canvastoimg";
const ShowImg2 = () => import("@/components/showimg2.vue");
const HdkShareGuide = () => import("@/components/hdk-share_guide.vue");
import Cookies from "js-cookie";
import QRCode from "qrcode";
export default {
  components: {
    ShareGuide,
    ShowImg2,
    HdkShareGuide
  },
  props: {
    cardUserInfo: Object
  },
  data() {
    return {
      //底部导航
      navData: [],
      isShowShareGuide: false, //是否显示网页分享
      isShowHdkShareGuide: false, //小程序环境下展示
      tabbarStyle: {},
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      }
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isInMiniProgram",
      "pageInfo",
      "userInfo",
      "shareSpreadInfo",
      "receiveSpreadInfo",
      "rsCardInfo"
    ]),
    evenNavData: function() {
      return this.navData.filter(function(item, i) {
        return item.isHide != true;
      });
    }
  },
  methods: {
    clickItem(item) {
      this[item.click]();
    },
    clickShare() {
      // 不管在小程序还是H5分享都改成线框指引
      this.isShowHdkShareGuide = true;
    },
    closeHdkShareGuide() {
      this.isShowHdkShareGuide = false;
    },
    clickChat() {
      util.openShqcWebChat(this.cardUserInfo.user.openid, this.cardUserInfo.ui.name);
    },
    clickCall() {
      util.makePhoneCall(this.cardUserInfo.ui.mobile);
    }
  },
  created() {
    let navData = [];

    navData = [
      {
        name: "分享朋友",
        click: "clickShare",
        class: "tabbar_wonder_h5",
        ico:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_share.png?x-oss-process=image/resize,h_100,w_100",
        no:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_share.png?x-oss-process=image/resize,h_100,w_100",
        yes:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_share.png?x-oss-process=image/resize,h_100,w_100"
      },
      {
        name: "在线咨询",
        click: "clickChat",
        class: "tabbar_poster_h5",
        ico:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_chat.png?x-oss-process=image/resize,h_100,w_100",
        no:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_chat.png?x-oss-process=image/resize,h_100,w_100",
        yes:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_chat.png?x-oss-process=image/resize,h_100,w_100"
      },
      {
        name: "一键致电",
        click: "clickCall",
        class: "tabbar_poster_h5",
        ico:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_tel.png?x-oss-process=image/resize,h_100,w_100",
        no:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_tel.png?x-oss-process=image/resize,h_100,w_100",
        yes:
          "https://assets.rurushishi.com/yq-rs-make/components/tabbar11/icon_tabbar_tel.png?x-oss-process=image/resize,h_100,w_100"
      }
    ];

    util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
      this.navData = navData;
    });
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}

/* 底部导航 */
.tabbar11 {
  width: 100%;
  height: p2r(80px);
  padding-bottom: p2r(40px);
  padding-top: p2r(10px);
  background: rgba(245, 245, 245, 1);
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 10;
}

.tabbar_item {
  text-align: center;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
}

.tabbar_item .tabbar_icon > img {
  width: 25px;
  height: 25px;
  padding: 5px;
}

.tabbar_item .tabbar_text {
  display: inline-block;
  font-size: 12px;
}

.tabbar_wonder_h5 {
  width: 18%;
  flex-direction: column;
  font-size: 13px;
}

.tabbar_wonder {
  width: 26%;
  flex-direction: column;
  font-size: 13px;
}

.tabbar_wonder .tabbar_text {
  font-size: 12px;
  color: #333333;
}

.tabbar_wonder .tabbar_icon {
  margin-right: 0px;
}

.tabbar_poster_h5 {
  width: 18%;
  flex-direction: column;
  font-size: 13px;
}

.tabbar_chat_h5 {
  width: 32%;
  background: linear-gradient(
    165deg,
    rgba(122, 189, 233, 1),
    rgba(116, 165, 242, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}

.tabbar_chat {
  width: 37%;
  background: linear-gradient(
    165deg,
    rgba(65, 196, 244, 1),
    rgba(98, 153, 244, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}

.tabbar_share_h5 {
  width: 32%;
  background: linear-gradient(
    165deg,
    rgba(240, 150, 52, 1),
    rgba(239, 83, 42, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}

.tabbar_share {
  width: 37%;
  background: linear-gradient(
    -15deg,
    rgba(244, 65, 66, 1),
    rgba(254, 144, 123, 1)
  );
  margin-right: 10px;
  color: #fff;
  border-radius: 5px;
}
</style>